<div class="container">
    <!-- Navbar -->
    <nav class="navbar navbar-expand-md navbar-light">
        <a class="navbar-brand mr-4" href="#">
            <img src="assets/logo_green_blue.svg" width="150" alt="Estudei">
        </a>
        <button class="navbar-toggler hidden-sm-up" type="button" (click)="isNavCollapsed = !isNavCollapsed"
            data-target="#navbarEstudei" aria-controls="navbarEstudei" aria-expanded="false" aria-label="Exibir Menu">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div [ngbCollapse]="isNavCollapsed" class="collapse navbar-collapse" id="navbarEstudei">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <a class="nav-link" (click)="GoSection(null)">Início</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="GoSection(divSignature)">Assinaturas</a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" (click)="GoSection(divUs)">Quem Somos</a>
                </li> -->
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['tutorial']">Tutoriais</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['editais']">Editais</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['blog']">Blog</a>
                </li>
            </ul>

            <form class="form-inline">
                <button class="btn btn-outline-secondary ml-auto" (click)="GoTo('/login')">Login</button>
                <button class="btn btn-info" (click)="GoSection(divSignature)">Assinar agora</button>
            </form>
        </div>
    </nav>
    <!-- /Navbar -->

    <!-- Conteúdo do Topo -->
    <div class="row top-content">
        <div class="col-12 col-sm-6 my-auto">
            <h1>Seu estudo organizado em um único lugar.</h1>
            <ng-container *ngIf="!pageVersion; else elseTemplate">
                <p>Você pode ter tempo e o melhor material do mundo, mas se não tiver
                    <strong>organização</strong>, <strong>planejamento</strong> e
                    <strong>método</strong>, não adianta
                </p>
            </ng-container>
            <ng-template #elseTemplate>
                <p>Planejamento inteligente, <strong>organização</strong>, estatísticas,
                    revisões e controle de tópicos para
                    <span *ngIf="pageVersion=='_enem'">ENEM e vestibulares</span>
                    <span *ngIf="pageVersion=='_rm'">futuros residentes</span>
                </p>
            </ng-template>
            <div class="d-flex mb-3" [ngStyle]="{'gap': '15px'}">
                <button class="btn btn-info" (click)="GoSection(divSignature)">Assinar agora</button>
                <!-- <button class="btn btn-outline-info" (click)="OpenVideo(modalVideo)">Ver vídeo</button> -->
            </div>
        </div>

        <div class="col">
            <img [src]="pathImageProvider+'a_header'+pageVersion+'.png'" alt="Estudei" class="w-100">
        </div>
    </div>
    <!-- /Conteúdo do Topo -->

    <!-- Cards Superiores -->
    <h3 class="title-sub-section mt-5">O <span>Estudei</span> é para você que:</h3>

    <div class="row top-cards">
        <div class="col">
            <div class="card">
                <div class="card-body text-center">
                    <img [src]="pathImageProvider+'b_blocks.svg'" alt="">
                    <p>Precisa de mais <strong>organização</strong> e <strong>método</strong> nos seus estudos.</p>
                </div>
            </div>

            <div class="card">
                <div class="card-body text-center">
                    <img [src]="pathImageProvider+'b_calendar.svg'" alt="">
                    <p>Não consegue criar um bom <strong>planejamento de estudos</strong>.</p>
                </div>
            </div>

            <div class="card">
                <div class="card-body text-center">
                    <img [src]="pathImageProvider+'b_search.svg'" alt="">
                    <p>Não sabe como organizar e fazer as <strong>revisões</strong>.</p>
                </div>
            </div>

            <div class="card">
                <div class="card-body text-center">
                    <img [src]="pathImageProvider+'b_arrow.svg'" alt="">
                    <p>Anda desmotivado(a) e <strong>sem metas</strong> claras para cumprir.</p>
                </div>
            </div>

            <div class="card">
                <div class="card-body text-center">
                    <img [src]="pathImageProvider+'b_clock.svg'" alt="">
                    <p>Quer <strong>controlar</strong> as horas estudadas e otimizar seu tempo.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- /Cards Superiores -->

    <!-- Gif da Plataforma -->
    <h3 class="title-sub-section mt-5">O <span>futuro dos seus<br />estudos</span> começa aqui.</h3>

    <div class="row gif">
        <div class="col">
            <div class="card">
                <div class="card-body" #Gif>
                    <iframe [width]="Gif.offsetWidth - 40" [height]="(Gif.offsetWidth-40) / 1.778"
                        src="https://www.youtube.com/embed/Jd2I7TCQe-U?autoplay=0&controls=1&loop=0&playlist=Jd2I7TCQe-U&rel=0"
                        title="Como funciona o Estudei?" frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen></iframe>
                </div>
            </div>
        </div>
    </div>
    <!-- /Gif da Plataforma -->

    <!-- Checks -->
    <h3 class="title-sub-section mt-5">Foque só no que importa: <span>estudar</span>.<br /> O resto cuidamos para você.
    </h3>

    <div class="row checks">
        <div class="col-12 col-md-5">
            <img [src]="pathImageProvider+'c_notebook_calendar.svg'" alt="Foque em estudar" class="mb-3">
        </div>

        <div class="col-12 col-md-7 my-auto">
            <div class="item" *ngFor="let item of checks; let i = index">
                <img [src]="(i+1)!=checks.length?(pathImageProvider+'c_check.svg'):(pathImageProvider+'c_times.svg')"
                    alt="Item">
                <p>{{ item }}</p>
            </div>
        </div>
    </div>

    <div class="row check-stats mt-5">
        <div class="col-auto" *ngFor="let stat of checkStats">
            <div class="card">
                <div class="card-body">
                    <div class="row my-auto">
                        <div class="col-auto my-auto">
                            <i [ngClass]="stat.icon"></i>
                        </div>

                        <div class="col pl-0 my-auto">
                            <p class="value">
                                {{ stat.value | mask:'separator.2':'.' }}
                                <span>{{ stat.unit }}</span>
                            </p>
                            <p class="description" [innerHTML]="stat.description"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /Checks -->

    <!-- Feedbacks 1 -->
    <div class="row mt-5" [ngStyle]="{'min-height': '460px'}">
        <div class="col-12 col-md-7 fb-statement">
            <h4 class="title-sub-section text-left">feedbacks</h4>
            <h3 class="title-sub-section text-left">Veja o que dizem<br /> nossos <span>usuários</span>:</h3>

            <p class="p" *ngFor="let paragraph of feedbacks1[selectedFeedback1].statement">{{ paragraph }}</p>
            <p class="a">{{ feedbacks1[selectedFeedback1].author }}</p>

            <div class="fb-points">
                <div *ngFor="let statement of [].constructor(feedbacks1.length); let s = index"
                    [class.active]="selectedFeedback1==s"></div>
            </div>
        </div>

        <div class="col-12 col-md-5">
            <div class="fb-medias">
                <div class="card" *ngFor="let statement of feedbacks1.slice(selectedFeedback1)"
                    [ngStyle]="{'background-image':'url('+pathImageProvider+statement.media+')'}">
                </div>
                <div class="card" [ngStyle]="{'background-image':'url('+pathImageProvider+feedbacks1[0].media+')'}">
                </div>

                <div class="fb-controls">
                    <i class="fas fa-circle-chevron-left" (click)="ChangeFeedback('-')"></i>
                    <i class="fas fa-circle-chevron-right" (click)="ChangeFeedback('+')"></i>
                </div>
            </div>

            <div class="quote">“</div>
        </div>
    </div>
    <!-- /Feedbacks 1 -->

    <!-- Como Funciona -->
    <h4 class="title-sub-section mt-5 text-left">como funciona</h4>
    <h3 class="title-sub-section text-left" [ngStyle]="{'max-width':'470px'}">Seu estudo na palma da mão em <span>4
            passos simples</span>:
    </h3>

    <div class="row how-works" *ngFor="let step of steps"
        [ngStyle]="{'flex-direction': step.id%2 ? null: 'row-reverse', 'margin-bottom': step.id!=4 ? '50px': '0'}">
        <div class="col-12 col-md-6 my-auto">
            <div class="row">
                <div class="col-auto">
                    <div class="calendar" [ngStyle]="{'background-image': 'url('+pathImageProvider+'b_calendar.svg)'}">
                        {{ step.id }}</div>
                </div>
                <div class="col my-auto">
                    <p>{{ 'passo ' + step.id }}</p>
                    <p>{{ step.title }}</p>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col">
                    <p *ngFor="let line of step.description" [innerHTML]="line"></p>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6">
            <div class="card">
                <div class="card-body">
                    <img [src]="pathImageProvider+step.image" alt="Passo a Passo de Funcionamento" class="w-100">
                </div>
            </div>
        </div>
    </div>
    <!-- /Como Funciona -->

    <!-- Spoiler -->
    <h4 class="title-sub-section mt-5">spoiler</h4>
    <h3 class="title-sub-section mx-auto" [ngStyle]="{'max-width':'470px'}">Essa é só a tela inicial do
        <span>Estudei</span>, imagina o resto?!
    </h3>

    <div class="row">
        <div class="col position-relative" [ngStyle]="{'overflow-x': 'auto'}">
            <div class="page-image"
                [ngStyle]="{'background-image': 'url('+pathImageProvider+'f_page'+pageVersion+'.png)'}">
                <div class="float-feature" *ngFor="let text of spoilers; let t = index">
                    {{ text }}
                    <img class="position-absolute" [src]="pathImageProvider+'f_arrow_'+(t+1)+'.png'" alt="Spoiler">
                </div>
            </div>
        </div>
    </div>
    <!-- /Spoiler -->

    <!-- Assinaturas -->
    <h4 class="title-sub-section mt-5" #divSignature>escolha sua assinatura</h4>
    <h3 class="title-sub-section mx-auto" [ngStyle]="{'max-width':'635px'}">Tenha a ferramenta que mais transforma
        <span>estudantes</span> em <span>aprovados</span>.
    </h3>

    <div class="subscriptions" [ngStyle]="{'height': 'calc('+subscriptionCard.offsetHeight+'px + 60px)'}">
        <div class="card"></div>
        <div class="card"></div>

        <div class="card" #subscriptionCard>
            <div class="card-body p-5">
                <div class="row">
                    <div class="col"></div>
                    <ng-container *ngFor="let item of subscriptions, let i = index">
                        <div class="col col-12 col-md-8 col-lg-6 col-xl-5 px-4 mb-4 position-relative">
                            <div class="card">
                                <div class="card-body text-center">
                                    <p>{{ item.period }}</p>
                                    <!-- <p>{{ item.oldPrice ? ('De R$' + (item.oldPrice |currency:'BRL':'':'1.2':'pt-BR') +
                                        ' por'): '&nbsp;' }}</p> -->
                                    <p></p>
                                    <p>
                                        {{ item.price |currency:'BRL':'':'1.2':'pt-BR' }}
                                        <span>R$</span>
                                        <span *ngIf="item.quota">{{ item.quota + 'X' }}</span>
                                    </p>
                                    <p>{{ item.observation || ('ou R$' + (item.cashPrice
                                        |currency:'BRL':'':'1.2':'pt-BR') + ' à vista') }}</p>

                                    <!-- <button class="btn btn-info mt-3 mb-1" (click)="GoCheckout(item.link)"> -->
                                    <button class="btn btn-info mt-3 mb-1" (click)="OpenAC(modalAC)">
                                        Assinar agora</button>
                                    <p>Sua compra é 100% segura</p>
                                </div>
                            </div>

                            <div class="recomended" *ngIf="i==1">
                                Recomendada
                            </div>

                            <!-- <div class="saving" *ngIf="item.saving">
                                <p>Economize</p>
                                <p>{{ 'R$' + (item.saving |currency:'BRL':'':'1.0':'pt-BR') }}</p>
                                <i class="fas fa-certificate"></i>
                            </div> -->

                            <div class="pda" [routerLink]="['planilha']" *ngIf="isPDA">
                                <div class="card">
                                    <div class="card-body">
                                        <p>É usuário da <strong>Planilha do Aprovado</strong>?</p>
                                        <p>Confira a oferta que preparamos para você!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <div class="col"></div>
                </div>
            </div>
        </div>
    </div>
    <!-- /Assinaturas -->

    <!-- Feedbacks 2 -->
    <div class="card-columns mt-5 fb-images">
        <div class="card">
            <h4 class="title-sub-section">feedbacks dos usuários</h4>
            <h3 class="title-sub-section mb-0">Mais alguns relatos de <br /> quem usa o <span>Estudei</span>:</h3>
        </div>

        <div class="card" *ngFor="let statement of feedbacks2">
            <div class="row">
                <div class="col-auto">
                    <div class="fb-profile"
                        [ngStyle]="{'background-image':'url('+pathImageProvider+statement.media+')'}"></div>
                </div>
                <div class="col fb-box">
                    <p>{{ statement.author }}</p>
                    <img [src]="pathImageProvider+statement.statement" alt="Feedback">
                </div>
            </div>
        </div>
    </div>
    <!-- /Feedbacks 2 -->

    <!-- Quem Somos Nós -->
    <h4 class="title-sub-section mt-5" #divUs>fundadores</h4>
    <h3 class="title-sub-section">Quem somos nós.</h3>

    <div class="row us-circles">
        <div class="col">
            <div *ngFor="let person of aboutUs; let p = index" (click)="selectedPerson=p" (mouseover)="selectedPerson=p"
                [class.selected]="selectedPerson==p"
                [ngStyle]="{'background-image': 'url('+pathImageProvider+person.image+')'}">
            </div>
        </div>
    </div>

    <div class="row mx-5 mt-3">
        <div class="col us-about">
            <p>{{ aboutUs[selectedPerson].about }}</p>
            <p>{{ '— ' + aboutUs[selectedPerson].name }}</p>
        </div>
    </div>
    <!-- /Quem Somos Nós -->

    <!-- FAQ -->
    <h4 class="title-sub-section mt-5">faq</h4>
    <h3 class="title-sub-section">Dúvidas frequentes.</h3>

    <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0" [closeOthers]="true">
        <ngb-panel [title]="item.question" *ngFor="let item of faq">
            <ng-template ngbPanelContent>
                <div [innerHTML]="item.answer"></div>
            </ng-template>
        </ngb-panel>
    </ngb-accordion>
    <!-- /FAQ -->
</div>

<!-- Footer -->
<div class="row mx-0 love my-5">
    <div class="col text-center">
        <p>
            Feito com
            <i class="fas fa-heart text-primary"></i>
            {{ withLove }}
        </p>

        <div class="social">
            <i class="fab fa-instagram" (click)="OpenSocial('i')"></i>
            <i class="fab fa-facebook-f" (click)="OpenSocial('f')"></i>
            <i class="fab fa-youtube" (click)="OpenSocial('y')"></i>
            <!-- <i class="fab fa-whatsapp" (click)="OpenSocial('w')"></i> -->
        </div>
    </div>
</div>

<footer>
    <div class="container">
        <div class="row pt-5">
            <div class="col">
                <img src="assets/logo_white_blue.svg" alt="Estudei" (click)="GoSection(null)">
            </div>

            <div class="col">
                <p (click)="GoDocuments('terms-of-use')">Termos de Uso</p>
                <p (click)="GoDocuments('privacy-policy')">Política de Privacidade</p>
            </div>

            <div class="col">
                <p>{{ (currentYear |date:'yyyy') + ' - Todos os direitos reservados' }}</p>
                <p>Seedy Soluções Tecnológicas em Educação LTDA</p>
                <p>CNPJ 49.020.659/0001-07</p>
                <p class="mt-2">contato&#64;estudei.com.br</p>
            </div>
        </div>
    </div>
</footer>
<!-- /Footer -->

<!-- WhatsApp -->
<div class="wa" (click)="OpenSocial('w')">
    <i class="fab fa-whatsapp"></i>
</div>
<!-- WhatsApp -->

<!-- Modal de Vídeo -->
<ng-template #modalVideo let-modal>
    <div class="modal-header" ngbAutoFocus>
        <h5>Vem aí... a evolução dos seus estudos</h5>
        <button type="button" class="close" (click)="modal.close()">
            <span>&times;</span>
        </button>
    </div>

    <div class="modal-body pb-4" #videoYT>
        <iframe [width]="videoYT.offsetWidth - 60" [height]="(videoYT.offsetWidth-60) / 1.778"
            src="https://www.youtube.com/embed/Jd2I7TCQe-U?autoplay=1"
            title="[Revelação!] Vem aí... a evolução dos seus estudos" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
    </div>
</ng-template>
<!-- /Modal de Vídeo -->

<!-- Modal do AC -->
<ng-template #modalAC let-modal>
    <div class="modal-header" ngbAutoFocus>
        <h5 class="text-center">Preencha seus dados para iniciar o cadastro!</h5>
    </div>
    <div class="modal-body pb-4">
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="name">Nome Completo*</label>
                    <input type="text" class="form-control" id="name" [(ngModel)]="preSubscription.name"
                        placeholder="Digite seu nome completo">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="mail">E-mail*</label>
                    <input type="email" class="form-control" id="mail" [(ngModel)]="preSubscription.email"
                        placeholder="Digite seu e-mail para realizar o cadastro">
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="phone">Telefone*</label>
                    <input type="text" class="form-control" id="phone" mask="(00) 0000-0000||(00) 0 0000-0000"
                        [(ngModel)]="preSubscription.phone" placeholder="(11) 9 6123-4567">
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col"></div>
            <div class="col-auto">
                <button class="btn btn-info" (click)="Subscribe()"
                    [disabled]="!preSubscription.name||!preSubscription.email||preSubscription.phone.length<10">Continuar</button>
            </div>
        </div>
    </div>
</ng-template>
<!-- /Modal do AC -->

<!-- Modal do App -->
<ng-template #modalApp let-modal>
    <div class="modal-app modal-body py-4">
        <button type="button" class="close" (click)="modal.close()">
            <span>&times;</span>
        </button>

        <div class="row">
            <div class="col-12 col-lg-7 pr-0" ngbAutoFocus>
                <p class="mapp-title">O <span>aplicativo</span> do Estudei está chegando! 📱</p>
                <p class="mapp-subtitle">A partir de <span>07/04</span>, além da plataforma web, você também
                    <strong>poderá usar o Estudei pelo app nativo!</strong>
                </p>
                <p class="mapp-subtitle">Inscreva-se para ser avisado do lançamento!</p>

                <div class="lp-form">
                    <input type="text" class="form-control w-50" id="name" [(ngModel)]="preSubscription.name"
                        placeholder="Nome">
                    <input type="text" class="form-control w-50" id="phone" mask="(00) 0000-0000||(00) 0 0000-0000"
                        [(ngModel)]="preSubscription.phone" placeholder="Telefone">
                    <input type="email" class="form-control w-100" id="mail" [(ngModel)]="preSubscription.email"
                        placeholder="E-mail">
                    <button class="btn btn-info w-100" (click)="SubscribeApp(modal)"
                        [disabled]="!preSubscription.name||!preSubscription.email||preSubscription.phone.length<10">
                        Quero ser avisado!</button>
                </div>
            </div>
            <div class="col-12 col-lg-5 pl-0 my-auto">
                <img src="https://estudei-frontend-web.s3.us-east-2.amazonaws.com/assets/app_multiplataform_4.png"
                    alt="">
            </div>
        </div>

        <div class="row">
            <div class="col">
                <p class="mapp-subtitle mb-0">(Ah, e é claro que todos os <strong>assinantes</strong> terão
                    <strong>acesso gratuito</strong> ao app!)
                </p>
            </div>
        </div>
    </div>
</ng-template>
<!-- /Modal do App -->